import React, {Component} from 'react';
import ReactDOM from 'react-dom';
import {observer} from 'mobx-react';
import styles from 'css/components/modal.css';
// import {ModalStore} from 'js/stores'; // singleton stores

@observer
/**
 * Modal
 */
export default class Modal extends Component {
  /**
   * constructor
   */
  constructor() {
    super();
    this.rootElm = document.getElementById('root');
    this.close = this.close.bind(this);
    this.stopEvent = this.stopEvent.bind(this);
  }

  /**
   * unmount
   */
  componentWillUnmount() {
    this.close();
  }

  /**
   * stop event
   * @param {object} e element
   */
  stopEvent(e) {
    e.stopPropagation();
  }

  /**
   * close modal
   */
  close() {
    this.props.close();
  }

  /**
   * render jsx
   * @return {jsx}
   */
  render() {
    return (
      ReactDOM.createPortal(
        <div className={styles.table}>
          <div className={styles.cell} onClick={this.close}>
            <div className={styles.body} onClick={this.stopEvent}>
              <a className={styles.close} onClick={this.close} />
              {this.props.children || ''}
            </div>
          </div>
        </div>,
        this.rootElm,
      )
    );
  }
}



// WEBPACK FOOTER //
// ./src/js/components/modal/index.js